export const COMPONENT_NAME = {
  // Basic components
  LABEL: 'label',
  SECTION: 'section',
  LINE: 'line',
  ELLIPSIS: 'ellipsis',
  SHAPE: 'shape',
  IMAGE: 'image',
  YOUTUBE: 'youtube',
  VIMEO: 'vimeo',
  ADMOB: 'admob',
  GROUP: 'group',
  LIST: 'list',
  INPUT: 'input',
  PASSWORD: 'password',
  COMPONENT: 'component',
  IMAGE_UPLOAD: 'imageUpload',
  FILE_UPLOAD: 'fileUpload',
  DATE_PICKER: 'datePicker',
  SELECT: 'select',
  FORM: 'form',
  WEB_VIEW: 'webView',
  INSTANCE: 'instance',
  TABLE: 'table',

  // Library components
  TOGGLE: 'toggle',
  BUTTON: 'button',
  ACTION_BUTTON: 'actionButton',
  ICON: 'icon',
  SWITCH: 'switch',
  TAB_NAVIGATOR: 'tabNavigator',
  APP_BAR: 'appBar',
  SIMPLE_LIST: 'simpleList',
  STRIPE_PAYMENT: 'stripePayment',
  STRIPE_SUBSCRIPTION: 'stripeSubscription',
  CARD_LIST: 'cardList',
  MAP: 'map',
  LINE_LOGIN: 'lineLogin',
  DOCOMO_LOGIN: 'docomoLogin',
  DID_LOGIN: 'didLogin',
  TRUSTDOCK_LOGIN: 'trustdockLogin',
  APPLE_LOGIN: 'appleLogin',
  CALENDAR: 'calendar',
  BAR_CODE: 'barCode',
  BARCODE_SCANNER: 'barcodeScanner',
  CAROUSEL: 'carousel',
  CHIP_LIST: 'chipList',
  AVATAR_LIST: 'avatarList',
  HORIZONTAL_CARD_LIST: 'horizontalCardList',
  UNIVA_PAY: 'univaPay',
  UNIVA_PAY_SUBSCRIPTION: 'univaPaySubscription',

  // Additional components
  STRIPE_PAYMENT_SECURITY: 'stripePaymentSecurity',
  IMAGE_UPLOAD_LIST: 'imageUploadList',
  RANKING_LIST: 'rankingList',
  SELECT_LIST: 'selectList',
  CUSTOM_HORIZONTAL_LIST: 'customHorizontalList',
  CUSTOM_BUTTON: 'customButton',
  CHANGE_QUANTITY: 'changeQuantity',
  IN_APP_PURCHASE: 'inAppPurchase',
  CUSTOMER_CHAT: 'customerChat',
  QUESTIONS: 'questions',
} as const;

export type ComponentName = typeof COMPONENT_NAME[keyof typeof COMPONENT_NAME];
